import { I18nextProvider } from "react-i18next";

import { Shell } from "@digital-services/shell";

import { authConfigOnly } from "./Auth/authConfig";
import useGetIdTokenHint from "./Auth/services/use-get-id-token-hint";
import useGetUserOrganizations from "./Auth/services/use-get-user-organizations";
import useInvalidateToken from "./Auth/services/use-invalidate-token";
import { useIsAuthorized } from "./Auth/services/use-is-authorized";
import i18nInstance from "./i18n";
import { FooterNavigationItems } from "./Shell/components/FooterNavigationItems";
import { MenuNavigation } from "./Shell/components/MenuNavigation";
import { NavBreadcrumbs } from "./Shell/components/NavBreadcrumbs";
import { useRouter } from "./Shell/hooks/useRouter";
import { Main } from "./Shell/Main";

export const App = () => {
  const { navigateToUrl } = useRouter();

  const getUserOrganizations = useGetUserOrganizations();
  const isAuthorized = useIsAuthorized();
  const getIdTokenHint = useGetIdTokenHint();
  const invalidateToken = useInvalidateToken();

  return (
    <I18nextProvider i18n={i18nInstance}>
      <Shell
        auth={{
          config: authConfigOnly,
          isAuthorized,
          getUserOrganizations,
          getIdTokenHint,
          onLogout: invalidateToken
        }}
        sidebar={{
          navItems: <MenuNavigation />,
          footerItems: <FooterNavigationItems />,
          onClickBranding: () => navigateToUrl("/")
        }}
        breadCrumbs={<NavBreadcrumbs />}
        applicationName="Update Management"
      >
        <div className="flex flex-1 flex-col gap-4 p-12 pt-4 transition-all duration-200">
          <Main />
        </div>
      </Shell>
    </I18nextProvider>
  );
};
